import { useState, type FormEvent } from "react";

const FORM_ACTION = "https://readdy.ai/api/form/dahhnfroh653ivfvnvr0";

export default function SubscribeForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);

    if (String(data.get("contact_alt") || "").trim()) {
      setStatus("success");
      setMessage("订阅成功，最新盘点整理会发送到你的邮箱。");
      form.reset();
      return;
    }
    data.delete("contact_alt");

    const params = new URLSearchParams();
    data.forEach((value, key) => {
      params.append(key, String(value));
    });

    setStatus("loading");
    setMessage("");
    try {
      const response = await fetch(FORM_ACTION, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });
      const responseText = await response.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");
      if (!response.ok || parsed?.code !== "OK" || isSpam) {
        setStatus("error");
        setMessage(serverMsg ? `提交失败：${serverMsg}` : "提交失败，请稍后重试。");
        return;
      }
      setStatus("success");
      setMessage("订阅成功，最新盘点整理会发送到你的邮箱。");
      form.reset();
    } catch {
      setStatus("error");
      setMessage("网络异常，请检查连接后重试。");
    }
  };

  return (
    <form
      id="subscribe-form"
      data-readdy-form
      action={FORM_ACTION}
      method="post"
      onSubmit={handleSubmit}
      className="w-full"
    >
      <div className="flex flex-col gap-3 sm:flex-row">
        <label className="flex-1">
          <span className="sr-only">邮箱地址</span>
          <input
            type="email"
            name="email"
            required
            placeholder="输入你的邮箱地址"
            autoComplete="email"
            className="h-12 w-full rounded-md border border-background-300 bg-background-50 px-4 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
          />
        </label>
        <label className="sm:w-44">
          <span className="sr-only">关注的分类</span>
          <select
            name="interest"
            defaultValue="all"
            className="h-12 w-full cursor-pointer rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
          >
            <option value="all">全部话题</option>
            <option value="yu-le">娱乐动态</option>
            <option value="ying-shi">影视综</option>
            <option value="pin-pai">品牌营销</option>
            <option value="chu-xing">出行消费</option>
            <option value="she-jiao">社交热点</option>
          </select>
        </label>
        <button
          type="submit"
          disabled={status === "loading"}
          className="inline-flex h-12 shrink-0 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
        >
          <i className={status === "loading" ? "ri-loader-4-line animate-spin" : "ri-mail-send-line"} />
          {status === "loading" ? "提交中" : "立即订阅"}
        </button>
        <input
          type="text"
          name="contact_alt"
          className="note-field-alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
        />
      </div>
      {status !== "idle" && status !== "loading" && (
        <p
          className={`mt-3 flex items-center gap-1.5 text-sm ${
            status === "success" ? "text-secondary-700" : "text-primary-700"
          }`}
          role={status === "error" ? "alert" : "status"}
        >
          <i className={status === "success" ? "ri-checkbox-circle-line" : "ri-error-warning-line"} />
          {message}
        </p>
      )}
      <p className="mt-3 text-xs text-foreground-400">
        我们只发送内容更新提醒，不会将邮箱用于其他用途，可随时退订。
      </p>
    </form>
  );
}